export const INFORMATION_ONLINE = "INFORMATION_ONLINE";
export const INFORMATION_OFFLINE = "INFORMATION_OFFLINE";
export const INFORMATION_FIRST_VIEW = "INFORMATION_FIRST_VIEW";
export const INFORMATION_SET_TRAINING = "INFORMATION_SET_TRAINING";
export const DATABASE_BLOCKED = "DATABASE_BLOCKED";
